var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[(_vm.isStatementsBatch)?_c('MailingsStatementsBatch'):_vm._e(),(_vm.isLettersBatch)?_c('MailingsLettersBatch'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }